import script from "./userSet.vue?vue&type=script&lang=ts&setup=true"
export * from "./userSet.vue?vue&type=script&lang=ts&setup=true"

import "./userSet.vue?vue&type=style&index=0&id=0a8e5b2e&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a8e5b2e"]])

export default __exports__